<template>
    <b-modal
      v-model="visible"
      :header-bg-variant="'secondary'"
      size="lg"
      no-close-on-backdrop
      hide-footer
    >
      <template v-slot:modal-header="{ close }">
        <h5 class="text-white">{{ title }}</h5>
        <b-button squared size="sm" variant="outline-success" @click="onClose">X</b-button>
      </template>
      <vue-custom-scrollbar class="scroll-area">
        <table class="table-scroll small-first-col">
          <thead>
            <tr>
              <th scope="col" v-for="(column, index) in keyItems" :key="index">{{column}}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in items" :key="index">
              <td :data-label="column" v-for="(column, indexColumn) in keyItems" :key="indexColumn">{{item[column]}}</td>
            </tr>
          </tbody>
        </table>
      </vue-custom-scrollbar>
    </b-modal>
  </template>
  <script>
  import vueCustomScrollbar from 'vue-custom-scrollbar'
  import "vue-custom-scrollbar/dist/vueScrollbar.css"

  export default {
    props: {
      visible: Boolean,
      title: String,
      data: Array,
    },

    components: {
      vueCustomScrollbar,
    },
  
    computed: {
      items() {
        return this.data.map(({id, cod_almacen, stock_carpetas, observaciones, ubigeo, reg_inicial, reg_final, agencia_id, created_at, updated_at, ...rest}) => ({...rest}))
      },
  
      keyItems() {
        if (this.items.length) {
          return Object.keys(this.items[0])
        }
        return []
      }
    },
  
    created: function () {
      this.$bus.$on('success', this.successful)
    },
  
    methods: {
      successful() {
        this.success = false
      },
  
      onClose() {
        this.$emit("hide");
      },
    }
  };
  </script>
  <style scoped src="../../../assets/css/table.css"></style>
  <style scoped>
    fieldset {
      background-color: #f9f9f9;
      border-radius: 4px;
    }

    legend {
      background-color: #fff;
      border: 1px solid #ddd;
      border-radius: 4px;
      color: #000;
      font-size: 17px;
      font-weight: bold;
      padding: 3px 5px 3px 7px;
      width: auto;
    }

    .scroll-area {
      position: relative;
      margin: auto;
      height: 200px;
    }
  </style>